import React from "react";

interface TitleProps {
  text: string;
  style?: React.CSSProperties;
  customSize?: "XLarge" | "Large";
}

const TedTitle: React.FC<TitleProps> = ({ text, style, customSize }) => {
  return (
    <span
      style={{
        fontFamily: "YekanBakhVF",
        fontSize: customSize === "Large" ? "40px" : "24px",
        fontWeight: "600",
        height: "48px",
        lineHeight: customSize === "Large" ? "40px" : "33.6px",
        ...style,
      }}
    >
      {text}
    </span>
  );
};

export default TedTitle;
